import { Predicate } from "@siteimprove/alfa-predicate";
import { Style } from "@siteimprove/alfa-style";
import { isIncludedInTheAccessibilityTree } from "./is-included-accessibility-tree.js";
const { and } = Predicate;
const { isVisible } = Style;
/**
 * Check if a node is perceivable for all users.
 *
 * @remarks
 * A node is considered perceivable for all if it's visible and has inclusive
 * descendants that are not ignored in the accessibility tree.
 *
 * @public
 */
export function isPerceivableForAll(device) {
    return and(isVisible(device), (node) => node.inclusiveDescendants().some(isIncludedInTheAccessibilityTree(device)));
}
//# sourceMappingURL=is-perceivable.js.map